var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDialog',{ref:"dialog_container",attrs:{"closeTop":2,"width":520,"dialogName":'RespondConfigurationDialog'}},[_c('SetupMenu',{attrs:{"configurationIds":_vm.configurationIds,"applyConfigurationsResponseOnDraft":_vm.applyConfigurationsResponseOnDraft},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }